import type { PixelGrid } from './AlienSprites';

/**
 * Pixel Art Icons for Main Upgrades
 * 16x16 pixel art sprites
 * 
 * Color Codes:
 * 0 = Transparent
 * 1 = Primary color (dark base)
 * 2 = Secondary color (medium shade)
 * 3 = Highlight (bright)
 * 4 = Accent/Detail (black or special)
 */

// DAMAGE UPGRADE - Powerful laser cannon
export const UPGRADE_ICON_DAMAGE: PixelGrid = [
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 3, 3, 3, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 3, 3, 3, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 3, 3, 3, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 1, 1, 1, 1, 2, 2, 2, 1, 1, 1, 1, 0, 0, 0],
  [0, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 0, 0],
  [1, 2, 2, 3, 3, 3, 3, 3, 3, 3, 3, 3, 2, 2, 1, 0],
  [1, 2, 2, 3, 3, 3, 3, 3, 3, 3, 3, 3, 2, 2, 1, 0],
  [0, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 0, 0],
  [0, 0, 1, 1, 1, 1, 2, 2, 2, 1, 1, 1, 1, 0, 0, 0],
  [0, 0, 0, 0, 1, 2, 2, 4, 2, 2, 1, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 1, 2, 4, 2, 1, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 1, 4, 1, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 1, 4, 1, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 4, 0, 0, 0, 0, 0, 0, 0, 0],
];

// SHIP UPGRADE - Detailed spaceship
export const UPGRADE_ICON_SHIP: PixelGrid = [
  [0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 1, 3, 1, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 1, 3, 1, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 1, 2, 3, 2, 1, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 1, 2, 3, 2, 1, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 1, 1, 2, 2, 3, 2, 2, 1, 1, 0, 0, 0, 0],
  [0, 0, 1, 2, 2, 2, 3, 3, 3, 2, 2, 2, 1, 0, 0, 0],
  [0, 1, 2, 2, 3, 3, 3, 4, 3, 3, 3, 2, 2, 1, 0, 0],
  [1, 2, 2, 3, 3, 3, 3, 4, 3, 3, 3, 3, 2, 2, 1, 0],
  [1, 3, 3, 3, 3, 2, 2, 2, 2, 2, 3, 3, 3, 3, 1, 0],
  [1, 2, 2, 2, 2, 1, 1, 1, 1, 1, 2, 2, 2, 2, 1, 0],
  [0, 1, 1, 1, 1, 0, 0, 0, 0, 0, 1, 1, 1, 1, 0, 0],
  [0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 0, 0, 0],
  [0, 3, 3, 3, 0, 0, 0, 0, 0, 0, 0, 3, 3, 3, 0, 0],
  [0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

// ATTACK SPEED - Lightning bolt
export const UPGRADE_ICON_ATTACK_SPEED: PixelGrid = [
  [0, 0, 0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 3, 3, 3, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 3, 3, 2, 3, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 3, 2, 2, 3, 3, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 3, 3, 2, 2, 2, 3, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 3, 2, 2, 2, 2, 3, 3, 0, 0, 0, 0, 0, 0, 0],
  [0, 3, 3, 2, 2, 1, 2, 2, 3, 0, 0, 0, 0, 0, 0, 0],
  [0, 3, 2, 2, 1, 1, 1, 2, 3, 3, 3, 3, 3, 0, 0, 0],
  [0, 3, 2, 1, 1, 1, 1, 3, 3, 2, 2, 2, 3, 0, 0, 0],
  [0, 0, 3, 1, 1, 1, 3, 3, 2, 2, 2, 3, 0, 0, 0, 0],
  [0, 0, 0, 3, 3, 3, 3, 2, 2, 2, 3, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 3, 2, 2, 2, 3, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 3, 2, 2, 3, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 3, 2, 3, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 3, 3, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 0],
];

// POINT MULTIPLIER - Sword with blade
export const UPGRADE_ICON_POINT_MULTIPLIER: PixelGrid = [
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 3, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 3, 3, 3, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 3, 3, 2, 3, 3, 3, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 3, 3, 2, 2, 2, 3, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 3, 3, 2, 2, 1, 2, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 3, 3, 2, 2, 1, 1, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 3, 3, 2, 2, 1, 1, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 3, 3, 2, 2, 1, 1, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 3, 3, 2, 2, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 3, 3, 2, 2, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 2, 2, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 1, 4, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 1, 2, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 1, 2, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

// CRIT CHANCE - Target with impact/explosion
export const UPGRADE_ICON_CRIT_CHANCE: PixelGrid = [
  [0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 3, 0, 0, 0, 0],
  [0, 0, 0, 0, 3, 0, 0, 0, 0, 0, 3, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0],
  [3, 0, 0, 0, 1, 2, 2, 2, 2, 2, 1, 0, 0, 0, 3, 0],
  [0, 3, 0, 1, 2, 2, 3, 3, 3, 2, 2, 1, 0, 3, 0, 0],
  [0, 0, 1, 2, 2, 3, 3, 4, 3, 3, 2, 2, 1, 0, 0, 0],
  [0, 0, 1, 2, 3, 3, 4, 4, 4, 3, 3, 2, 1, 0, 0, 0],
  [0, 0, 1, 2, 3, 4, 4, 1, 4, 4, 3, 2, 1, 0, 0, 0],
  [0, 0, 1, 2, 3, 3, 4, 4, 4, 3, 3, 2, 1, 0, 0, 0],
  [0, 0, 1, 2, 2, 3, 3, 4, 3, 3, 2, 2, 1, 0, 0, 0],
  [0, 3, 0, 1, 2, 2, 3, 3, 3, 2, 2, 1, 0, 3, 0, 0],
  [3, 0, 0, 0, 1, 2, 2, 2, 2, 2, 1, 0, 0, 0, 3, 0],
  [0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 3, 0, 0, 0, 0, 0, 3, 0, 0, 0, 0, 0],
  [0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 3, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

// ENERGY CORE - Power core/reactor
export const UPGRADE_ICON_ENERGY_CORE: PixelGrid = [
  [0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0],
  [0, 0, 0, 1, 1, 2, 2, 2, 2, 2, 2, 1, 1, 0, 0, 0],
  [0, 0, 1, 2, 2, 2, 3, 3, 3, 3, 2, 2, 2, 1, 0, 0],
  [0, 1, 2, 2, 3, 3, 3, 3, 3, 3, 3, 3, 2, 2, 1, 0],
  [0, 1, 2, 3, 3, 3, 3, 4, 4, 3, 3, 3, 3, 2, 1, 0],
  [1, 2, 2, 3, 3, 3, 4, 3, 3, 4, 3, 3, 3, 2, 2, 1],
  [1, 2, 3, 3, 3, 4, 3, 3, 3, 3, 4, 3, 3, 3, 2, 1],
  [1, 2, 3, 3, 4, 3, 3, 3, 3, 3, 3, 4, 3, 3, 2, 1],
  [1, 2, 3, 3, 4, 3, 3, 3, 3, 3, 3, 4, 3, 3, 2, 1],
  [1, 2, 3, 3, 3, 4, 3, 3, 3, 3, 4, 3, 3, 3, 2, 1],
  [1, 2, 2, 3, 3, 3, 4, 3, 3, 4, 3, 3, 3, 2, 2, 1],
  [0, 1, 2, 3, 3, 3, 3, 4, 4, 3, 3, 3, 3, 2, 1, 0],
  [0, 1, 2, 2, 3, 3, 3, 3, 3, 3, 3, 3, 2, 2, 1, 0],
  [0, 0, 1, 2, 2, 2, 3, 3, 3, 3, 2, 2, 2, 1, 0, 0],
  [0, 0, 0, 1, 1, 2, 2, 2, 2, 2, 2, 1, 1, 0, 0, 0],
  [0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0],
];

// PASSIVE INCOME (RESOURCE GEN) - Factory/Generator
export const UPGRADE_ICON_RESOURCE_GEN: PixelGrid = [
  [0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0],
  [0, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 0],
  [1, 2, 2, 3, 3, 2, 2, 3, 3, 2, 2, 3, 3, 2, 2, 1],
  [1, 2, 3, 4, 4, 3, 3, 4, 4, 3, 3, 4, 4, 3, 2, 1],
  [1, 2, 2, 3, 3, 2, 2, 3, 3, 2, 2, 3, 3, 2, 2, 1],
  [1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1],
  [1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1],
  [1, 2, 1, 3, 3, 3, 1, 3, 3, 3, 1, 3, 3, 3, 1, 1],
  [1, 2, 1, 3, 4, 3, 1, 3, 4, 3, 1, 3, 4, 3, 1, 1],
  [1, 2, 1, 3, 3, 3, 1, 3, 3, 3, 1, 3, 3, 3, 1, 1],
  [1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1],
  [1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1],
  [0, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 0],
  [0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

// XP BOOST - Star level-up icon
export const UPGRADE_ICON_XP_BOOST: PixelGrid = [
  [0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 1, 3, 1, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 1, 3, 1, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 1, 2, 3, 2, 1, 0, 0, 0, 0, 0, 0],
  [0, 1, 1, 1, 1, 2, 2, 3, 2, 2, 1, 1, 1, 1, 0, 0],
  [0, 0, 1, 2, 2, 2, 3, 3, 3, 2, 2, 2, 1, 0, 0, 0],
  [0, 0, 0, 1, 2, 3, 3, 3, 3, 3, 2, 1, 0, 0, 0, 0],
  [0, 0, 0, 1, 2, 3, 3, 4, 3, 3, 2, 1, 0, 0, 0, 0],
  [0, 0, 1, 2, 2, 3, 3, 3, 3, 3, 2, 2, 1, 0, 0, 0],
  [0, 1, 2, 2, 3, 3, 3, 3, 3, 3, 3, 2, 2, 1, 0, 0],
  [1, 2, 2, 3, 3, 3, 2, 3, 2, 3, 3, 3, 2, 2, 1, 0],
  [1, 2, 3, 3, 3, 2, 1, 3, 1, 2, 3, 3, 3, 2, 1, 0],
  [0, 1, 2, 3, 2, 1, 0, 3, 0, 1, 2, 3, 2, 1, 0, 0],
  [0, 0, 1, 2, 1, 0, 0, 3, 0, 0, 1, 2, 1, 0, 0, 0],
  [0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

// MUTATION ENGINE - Clear DNA double helix
export const UPGRADE_ICON_MUTATION_ENGINE: PixelGrid = [
  [1, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 3, 1, 0],
  [0, 1, 3, 1, 0, 0, 0, 0, 0, 0, 0, 1, 3, 1, 0, 0],
  [0, 0, 1, 3, 1, 0, 0, 0, 0, 0, 1, 3, 1, 0, 0, 0],
  [0, 0, 0, 1, 3, 1, 0, 0, 0, 1, 3, 1, 0, 0, 0, 0],
  [0, 0, 0, 0, 1, 3, 1, 2, 1, 3, 1, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 1, 3, 2, 3, 1, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 1, 2, 1, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 1, 2, 1, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 1, 2, 1, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 1, 3, 2, 3, 1, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 1, 3, 1, 2, 1, 3, 1, 0, 0, 0, 0, 0],
  [0, 0, 0, 1, 3, 1, 0, 0, 0, 1, 3, 1, 0, 0, 0, 0],
  [0, 0, 1, 3, 1, 0, 0, 0, 0, 0, 1, 3, 1, 0, 0, 0],
  [0, 1, 3, 1, 0, 0, 0, 0, 0, 0, 0, 1, 3, 1, 0, 0],
  [1, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 3, 1, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

// MISC/R&D - Science beaker with formula
export const UPGRADE_ICON_MISC: PixelGrid = [
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 1, 2, 2, 2, 2, 2, 1, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 1, 2, 2, 2, 2, 2, 1, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 1, 2, 3, 2, 1, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 1, 2, 1, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 1, 2, 2, 2, 1, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 1, 2, 3, 2, 3, 2, 1, 0, 0, 0, 0, 0],
  [0, 0, 0, 1, 2, 2, 2, 2, 2, 2, 2, 1, 0, 0, 0, 0],
  [0, 0, 1, 2, 3, 2, 2, 3, 2, 2, 3, 2, 1, 0, 0, 0],
  [0, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 0, 0],
  [0, 1, 2, 3, 2, 2, 3, 2, 3, 2, 2, 3, 2, 1, 0, 0],
  [0, 0, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 0, 0, 0],
  [0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

/**
 * Map of upgrade IDs to their pixel art sprites
 */
export const MAIN_UPGRADE_SPRITES: Record<string, PixelGrid> = {
  damage: UPGRADE_ICON_DAMAGE,
  ship: UPGRADE_ICON_SHIP,
  attackSpeed: UPGRADE_ICON_ATTACK_SPEED,
  pointMultiplier: UPGRADE_ICON_POINT_MULTIPLIER,
  critChance: UPGRADE_ICON_CRIT_CHANCE,
  energyCore: UPGRADE_ICON_ENERGY_CORE,
  resourceGen: UPGRADE_ICON_RESOURCE_GEN,
  xpBoost: UPGRADE_ICON_XP_BOOST,
  mutationEngine: UPGRADE_ICON_MUTATION_ENGINE,
  misc: UPGRADE_ICON_MISC,
};

/**
 * Get sprite for an upgrade by ID
 */
export function getMainUpgradeSprite(id: string): PixelGrid | null {
  return MAIN_UPGRADE_SPRITES[id] ?? null;
}

